const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
const _require2 = require('../lib/environmental'),
  celsiusFromFahrenheit = _require2.celsiusFromFahrenheit,
  dewPoint = _require2.dewPoint,
  fahrenheitFromCelsius = _require2.fahrenheitFromCelsius;

/**
  * @function evalute - evaluate dewPointBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const dryBulbFahrenheit = await evaluateSource(source.dryBulbSource, content, parentContentPath, transientContext, nativeFunctions);
  if (Number.isNaN(Number(dryBulbFahrenheit))) {
    return undefined;
  }
  const dryBulbCelsius = celsiusFromFahrenheit(dryBulbFahrenheit);
  const relativeHumidityValue = await evaluateSource(source.relativeHumiditySource, content, parentContentPath, transientContext, nativeFunctions);
  if (Number.isNaN(Number(relativeHumidityValue))) {
    return undefined;
  }
  const dewPointCelsius = dewPoint(dryBulbCelsius, relativeHumidityValue);
  if (Number.isNaN(Number(dewPointCelsius))) {
    return undefined;
  }
  return fahrenheitFromCelsius(dewPointCelsius);
};
module.exports = {
  evaluate
};